import { TreeLevel } from 'components/DependencyTrees/CustomTreeLevel';
import { ReportItem } from 'store/ducks/Reporting/types';

export const bruEvidenceLevels: TreeLevel<ReportItem>[] = [
  {
    groupBy: (i) => i.bru_key_value,
    getKey: (g) => `bru-${g}`,
    getLabel: (i) => i.bru_key_value
  },

  {
    groupBy: (i) => i.evd_sol_desc ?? '-',
    getKey: (g) => `solution-${g}`,
    getLabel: (i) => i.evd_sol_desc ?? '-'
  },

  {
    groupBy: (i) => String(i.evd_id),
    getKey: (g) => `evidence-${g}`,
    getLabel: (i) => i.evd_description ?? '-'
  }
];
